import { ConfigProvider, Layout as AntLayout } from "antd";
import { Outlet } from "react-router-dom";

import "antd/dist/reset.css";
import AppHeader from "../header/AppHeader";
import { AntLayoutStyled, ContentStyled } from "./styled";

const themeConfig = {
  token: {
    fontFamily: "Inter, sans-serif",
  },
};

const Layout = () => {
  return (
    <ConfigProvider theme={themeConfig}>
      <AntLayoutStyled>
        <AntLayout>
          <AppHeader />
          <ContentStyled>
            <Outlet />
          </ContentStyled>
        </AntLayout>
      </AntLayoutStyled>
    </ConfigProvider>
  );
};

export default Layout;
